import script from "./BotMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BotMenu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"BotMenu.vue"]])

export default __exports__